<vectronic-layout-with-sidebar
  [hasSideBar]="tableSelectionService.hasSingle()"
  [hasLeftMenu]="true"
>
  @if (!hideFilter()) {
    <ng-template #leftSide>
      <div class="schedule-templates__filter">
        <rc-schedule-template-filter
          [searchFilter]="searchFilter()"
          [availableUserAccounts]="availableUserAccounts()"
          (scheduleTypeChange)="onScheduleTypeChange($event)"
          (templateNameChange)="onTemplateNameChange($event)"
          (userIdsChange)="onUserIdsChange($event)"
        ></rc-schedule-template-filter>
      </div>
    </ng-template>
  }

  <ng-template #table>
    <div class="schedule-templates">
      <table-datatable [datatableConfig]="datatableConfig()" [data]="rows()">
        <ng-template #headerButtons>
          <button
            class="schedule-templates__action-button"
            mat-button
            [attr.data-testid]="'new-schedule-template'"
            (click)="openNewScheduleTemplateDialog()"
          >
            <mat-icon color="accent">add</mat-icon>
            New Schedule Template
          </button>
        </ng-template>
      </table-datatable>
    </div>
  </ng-template>

  <ng-template #single>
    <vectronic-card
      [title]="selectedTemplate()?.templateName"
      [displayClose]="true"
      (closed)="tableSelectionService.singleSelection.clear()"
      class="schedule-templates__single-card"
    >
      <div body class="schedule-templates__single-card-body">
        @if (selectedTemplate()) {
          <rc-edit-schedule-template
            [scheduleTemplate]="selectedTemplate()"
            [hideCustomerVisibility]="hideCustomerVisibility()"
            [hideUserId]="hideUserId()"
            (save)="onSaveTemplate($event)"
            [readonly]="isSelectedReadonly()"
            [hasHighActivityCameraTrigger]="true"
          ></rc-edit-schedule-template>
        }
      </div>
    </vectronic-card>
  </ng-template>
</vectronic-layout-with-sidebar>
